import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import { framesProjects } from "@/data/portfolio";

const FramesGallery = () => (
    <section data-testid="frames-section" className="relative py-12 sm:py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeading
                index={5}
                eyebrow="Design Work"
                title={
                    <>
                        My{" "}
                        <em className="font-serifit text-[1.06em] font-medium italic text-[#f6e3d3]">
                            Frames
                        </em>
                    </>
                }
                subtitle="Static design work — posters, thumbnails, typography and visual experiments."
            />

            <div className="columns-1 gap-6 sm:columns-2 sm:gap-6 lg:columns-3">
                {framesProjects.map((p, i) => (
                    <Reveal
                        key={p.id}
                        delay={(i % 3) * 0.08}
                        className="mb-6 break-inside-avoid"
                    >
                        <div
                            data-testid={`frames-card-${p.id}`}
                            className="group relative overflow-hidden rounded-3xl border border-white/10 bg-ink-3 transition-[border-color] duration-500 hover:border-flame/40"
                        >
                            <img
                                src={p.thumbnail}
                                alt={p.title}
                                loading="lazy"
                                className="aspect-video w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
                            />
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default FramesGallery;
